var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18m-.75 5V4h1.5v2zm0 10V8h1.5v8z",
    clipRule: "evenodd"
  })));
};
export { SvgInfoCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAgMUM1LjAyOTQ0IDEgMSA1LjAyOTQ0IDEgMTBDMSAxNC45NzA2IDUuMDI5NDQgMTkgMTAgMTlDMTQuOTcwNiAxOSAxOSAxNC45NzA2IDE5IDEwQzE5IDUuMDI5NDQgMTQuOTcwNiAxIDEwIDFaTTkuMjUgNlY0SDEwLjc1VjZIOS4yNVpNOS4yNSAxNlY4SDEwLjc1VjE2SDkuMjVaIiAvPgo8L3N2Zz4K";